var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", { staticClass: "table rate-table" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "tbody",
      [
        _c("tr", [
          _vm._m(1),
          _vm._v(" "),
          _c("td", [_vm._v(" " + _vm._s(_vm.reservation.first_name))]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _vm._m(2),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.reservation.last_name))]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _vm._m(3),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.reservation.address_primary))]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _vm._m(4),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.reservation.phone))]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _vm._m(5),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.reservation.email))]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _vm._m(6),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.reservation.city))]),
        ]),
        _vm._v(" "),
        _vm.reservation.is_international_customer ||
        parseInt(this.$store.state.resources.config.is_international_canadian)
          ? [
              _c("tr", [
                _vm._m(7),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.reservation.country))]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _vm._m(8),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.reservation.postal_code))]),
              ]),
            ]
          : [
              _c("tr", [
                _vm._m(9),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.reservation.state))]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _vm._m(10),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.reservation.zip))]),
              ]),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { colspan: "2" } }, [_vm._v("Primary renter")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { width: "35%" } }, [
      _c("strong", [_vm._v("First name:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Last name:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Primary Address:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Mobile Phone:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Email:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("City:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Country:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Postal code:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("State:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Zip:")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }